import { fetchWithoutToken } from '../utils/fetch';

export const getInfoUserCanvas = async (codeParam, institutionCode) => {
	const getCredentials = (code) => {
		switch (code) {
			case 'CMVC':
				return {
					client_id: process.env.REACT_APP_CLIENTID_CMVC_CANVAS,
					client_secret: process.env.REACT_APP_CLIENTSECRET_CMVC_CANVAS,
					domain: 'compumed',
				};
			case 'ASP':
				return {
					client_id: process.env.REACT_APP_CLIENTID_ASP,
					client_secret: process.env.REACT_APP_CLIENTSECRET_ASP,
					domain: 'aspatria',
				};
			case 'DOINS':
				return {
					client_id: process.env.REACT_APP_CLIENTID_DOINS,
					client_secret: process.env.REACT_APP_CLIENTSECRET_DOINS,
					domain: 'dominiuminstitute',
				};
			case 'UTH':
				return {
					client_id: process.env.REACT_APP_CLIENTID_UTH,
					client_secret: process.env.REACT_APP_CLIENTSECRET_UTH,
					domain: 'uthflorida',
				};
			case 'HCAS':
				return {
					client_id: process.env.REACT_APP_CLIENTID_HCAS,
					client_secret: process.env.REACT_APP_CLIENTSECRET_HCAS,
					domain: 'hcas',
				};
			case 'CBT':
				return {
					client_id: process.env.REACT_APP_CLIENTID_CBT,
					client_secret: process.env.REACT_APP_CLIENTSECRET_CBT,
					domain: 'cbt',
				};
			case 'SABER':
				return {
					client_id: process.env.REACT_APP_CLIENTID_SABER,
					client_secret: process.env.REACT_APP_CLIENTSECRET_SABER,
					domain: 'sabercollege',
				};
			case 'BRC':
				return {
					client_id: process.env.REACT_APP_CLIENTID_BRC,
					client_secret: process.env.REACT_APP_CLIENTSECRET_BRC,
					domain: 'braxtoncollege',
				};
			case 'LSN':
				return {
					client_id: process.env.REACT_APP_CLIENTID_LSN,
					client_secret: process.env.REACT_APP_CLIENTSECRET_LSN,
					domain: 'lsn',
				};
			case 'ST':
				return {
					client_id: process.env.REACT_APP_CLIENTID_ST,
					client_secret: process.env.REACT_APP_CLIENTSECRET_ST,
					domain: 'stratatech',
				};
			case 'BETAUNI':
				return {
					client_id: process.env.REACT_APP_CLIENTID_BETAUNI_CANVAS,
					client_secret: process.env.REACT_APP_CLIENTSECRET_BETAUNI_CANVAS,
					domain: 'betauni',
				};
			case 'LAURELI':
				return {
					client_id: process.env.REACT_APP_CLIENTID_LAURELI_CANVAS,
					client_secret: process.env.REACT_APP_CLIENTSECRET_LAURELI_CANVAS,
					domain: 'lbi',
				};
			case 'OBC':
				return {
					client_id: process.env.REACT_APP_CLIENTID_OBC_CANVAS,
					client_secret: process.env.REACT_APP_CLIENTSECRET_OBC_CANVAS,
					domain: 'obc',
				};
			case 'MTA':
				return {
					client_id: process.env.REACT_APP_CLIENTID_MTA_CANVAS,
					client_secret: process.env.REACT_APP_CLIENTSECRET_MTA_CANVAS,
					domain: 'mta',
				};
			case 'DTH':
				return {
					client_id: process.env.REACT_APP_CLIENTID_DTH_CANVAS,
					client_secret: process.env.REACT_APP_CLIENTSECRET_DTH_CANVAS,
					domain: 'dadeinstitute',
				};
			case 'SMUR':
				return {
					client_id: process.env.REACT_APP_CLIENTID_SMUR_CANVAS,
					client_secret: process.env.REACT_APP_CLIENTSECRET_SMUR_CANVAS,
					domain: 'canvas.smufl.us',
				};
			case 'OMI':
				return {
					client_id: process.env.REACT_APP_CLIENTID_OMI_CANVAS,
					client_secret: process.env.REACT_APP_CLIENTSECRET_OMI_CANVAS,
					domain: 'omi',
				};
			default:
				return {
					client_id: process.env.REACT_APP_CLIENTID_CMVC_CANVAS,
					client_secret: process.env.REACT_APP_CLIENTSECRET_CMVC_CANVAS,
					domain: 'compumed',
				};
		}
	};

	try {
		const res = await fetchWithoutToken.post(
			`/canvas`,
			{
				client_id: getCredentials(institutionCode).client_id,
				client_secret: getCredentials(institutionCode).client_secret,
				code: codeParam,
				base_url:
					institutionCode !== 'SMUR'
						? `https://${
								getCredentials(institutionCode).domain
						  }.instructure.com`
						: `https://${getCredentials(institutionCode).domain}`,
			},
			{
				headers: {
					Authorization: `Bearer ${localStorage.token}`,
				},
			}
		);
		return res;
	} catch (error) {
		console.error('Your authorization token has expired or is incorrect.');
		return null;
	}
};
